module.exports = {
  language: {
    name: '中文',
    current: '当前语言',
  },
  // 头部
  common: {
    pagination: '共{allNum}条',
    more: '了解更多',
    consult: '咨询展商',
    talk: '咨询展商',
    favorites: '收藏展商',
    cancel: '取消收藏',
    collected: '已收藏',
    collect: '收藏',
    clear: '清空',
    clearCollect: '取消收藏',
    collectExhibits: '收藏展品',
    collectExhibition: '收藏展商',
    collectLive: '收藏直播',
    collectActivity: '收藏活动',
    screenConditions: '筛选条件',
    screen1: '按产品类型筛选',
    screen2: '按展馆筛选',
    hall: '馆',
    successCollect: '收藏成功！',
    cancelCollect: '取消收藏成功！',
    boothNum1: '展位号：',
    options: '操作',
    download: '下载',
    viewMore: '查看更多',
    viewMoreMobile: '查 看 更 多',
    close: '关闭',
    sure: '确定',
    share: '分享',
    mobileLive: '直播',
  },
  navbar: {
    title: '第二十届中国国际煤炭采矿技术交流及设备展览会',
    theme: 'China Coal & Mining Expo 2023',
    time: '北京中国国际展览中心（新馆） 2023年10月25-26日',
    home: '首页',
    exhibition: '展商',
    exhibits: '展品',
    live: '直播',
    activity: '活动中心',
    onlineHall: '线上展厅',
    VRview: 'VR看展',
    imgView: '图片看展',
    videoView: '视频看展',
    onlineWeb: '展会官网',
    audienceLogin: '观众登录',
    audienceCenter: '观众后台',
    exhibitionLogin: '展商登录',
    exhibitionCenter: '展商后台',
    zh: '中文',
    en: 'English',
    about: '关于我们',
    join: '加入我们',
    contact: '联系我们',
    join: '我要参展',
    exhibitionLists: '展商列表',
    exhibitsLists: '展品列表',
  },
  mobileRecommend: {
    UndergroundMining: '井下开采',
    UndergroundTunneling: '井下掘进',
    UndergroundTransportation: '井下运输',
    CoalMineElectromechanicalandPower: '煤矿机电与动力',
    CoalMineAuxiliaryProductionSystem: '煤矿辅助生产系统',
    SMARTMineAutomation: '自动化控制和煤矿智能化',
    CoalProcessingUtilization: '煤炭加工利用',
    Open_AirMining: '露天采矿',
    CoalMineServicesandEngineering: '矿山服务与工程',
    MineMaterialInstrumentsandProcessing: '矿用物资、工具及加工制造',
  },
  //   展商
  exhibition: {
    placeholder: '请输入企业',
    boothNum: '展位号',
    sendCard: '递名片',
    noexhibition: '暂时没有相关展商',
    detailTitle: '展商详情',
    go: '前往',
    place: '展位',
    boothArea: '展位面积：',
    companyNature: '企业性质：',
    companyAddress: '公司地址：',
    companyWebsite: '公司网址：',
    companyPhone: '公司电话：',
    companyEmail: '联系邮箱：',
    exhibitionIntroduce: '展商介绍',
    productCenter: '产品中心',
    productSeries: '产品系列',
    openMore: '展开更多',
    live: '展商直播',
    activity: '展商活动',
    activityType: '活动类型',
    news: '展商新闻',
    informations: '展商资料',
    infoName: '资料名称',
    infoSize: '大小',
    tip1: '请登录观众账号后进行下载!',
    lastPage: '上一篇',
    nextPage: '下一篇',
    allProducts: '全部产品',
    allActivity: '全部活动',
    mobileDetail: '+ 详情',
  },
  exhibits: {
    placeholder: '请输入产品名称关键字',
    noData: '暂无筛选结果',
    detailTitle: '展品详情',
    productModel: '产品型号：',
    prosuctSeries: '产品系列：',
    productCategory: '产品类别：',
    productIntroduce: '展品介绍',
    productParameter: '展品参数',
    productTravelBrochure: '展品宣传资料',
    infoName: '宣传资料名称',
    other: '其他展品',
  },
  live: {
    placeholder: '请输入关键字',
    tab1: '10月25日',
    tab2: '10月26日',
    tab3: '10月27日',
    tab4: '10月28日',
    tip: '手机扫描二维码观看直播',
    detailTitle: '直播详情',
    liveIntroduce: '直播简介',
  },
  activity: {
    placeholder: '请输入关键字',
    all: '全部',
    place: '地点',
    nodata: '暂时没有活动',
    technicalMeeting: '技术交流会',
    forum: '论坛',
    productLaunch: '产品发布会',
    standActivities: '展台活动',
    otherActivity: '其他活动',
    detailTitle: '活动详情',
    startTime: '开始时间：',
    endTime: '结束时间：',
    placeBooth: '地址：展台',
    activityIntroduce: '活动介绍',
  },
  footer: {
    title: '第二十届中国国际煤炭采矿技术交流及设备展览会组委会',
    titleTop: '第二十届',
    titleBottom: '中国国际煤炭采矿技术交流及设备展览会组委会',
    link: '快速链接',
    company: '汇显展览有限公司',
    weChatOfficialAccount: '展览会微信公众号',
    qrCodeAttention: '请扫描二维码进行关注',
    mobileQrCodeAttention: '请扫描二维码关注展览会微信公众号',
    copyright: '版权所有：中国煤炭工业国际技术咨询有限责任公司',
    technicalSupport: '技术支持：中煤信息技术(北京)有限公司',
    spareNumber1: '京公网安备11010102002548号',
    spareNumber2: '京ICP备09033595号-1',
    address: '北京市东城区安外大街192号煤机大厦',
    linkUrl: {
      viewcz: '我要参展',
      viewcg: '我要参观',
      zwt: '展位图',
      zhrc: '展会日程',
      hzZhanhui: '展会官网',
      mjlt: '煤机论坛',
    },
    unit: {
      title1: '主办单位',
      title2: '协办单位',
      title3: '承办单位',
      text1: '中国煤炭工业协会',
      text2: '中国中煤能源集团有限公司',
      text3: '中国煤炭工业国际技术咨询有限责任公司',
    },
  },
  homePage: {
    quickFind: '快捷查找展品展商',
    quickFind1: '快捷查找展商',
    quickFind2: '快捷查找展品',
    placeholder1: '请选择',
    placeholder2: '请输入关键字',
    search: '搜索',
    productRecommend: '展品推荐',
    vr: {
      title: '全景呈现',
      txt:
        '中国国际采矿展组委会首次通过VR技术将第二十届中国国际煤炭采矿技术交流及设备展览会线下展会12个场馆的全景进行线上呈现，让您有身临其境之感，通过VR看展技术您还可以进行展馆定位，查找品牌展商、搜索展品、互动交流等。精彩瞬间永驻线上，打造永不落幕的中国国际采矿展。',
    },
    exhibition: {
      title: '展商推荐',
      no: '暂无',
    },
    live: {
      title: '展商直播',
      qrAlt: '二维码',
    },
    activity: {
      title: '精彩活动',
    },
    handle: {
      handle0: '请选择展品类型',
      handle1: '请选择展商类型',
    },
    searchCategory: {
      searchCategory0: '搜展品',
      searchCategory1: '搜展商',
    },
  },
  message: {
    isLimit: '只能登录一个账号!',
    audienceAccount: '请登录观众账号!',
    noLogin: '未登录',
    goLogin: '去登录',
    isDownload: '是否要下载',
  },
  share: {
    friend: '分享到朋友圈',
    wechat: '分享到微信',
    link: '复制链接',
  },
};
